import React from 'react';

import { Chip, CircularProgress } from '@mui/material';

import { type EgsRoomMatch, getEgsMatchStatusColor, getEgsMatchStatusLabel, getRoomDataState } from './egsRoomMatcher';

interface Props {
  error: unknown;
  hasRoomTypes: boolean;
  isLoading: boolean;
  match: EgsRoomMatch;
}

// Order matters: with no room types to compare against, the chip withholds a verdict rather than saying
// "No match". Nothing here promises the apply will succeed.
export default function EgsMatchStatusChip({ error, hasRoomTypes, isLoading, match }: Props) {
  const roomDataState = getRoomDataState({ error, hasRoomTypes, isLoading });

  if (roomDataState === 'error') {
    return <>—</>;
  }

  if (roomDataState === 'loading') {
    return <CircularProgress size={16} />;
  }

  const label = getEgsMatchStatusLabel({ error, hasRoomTypes, isLoading, match });

  return label ? <Chip color={getEgsMatchStatusColor(match)} label={label} size="small" variant="outlined" /> : <>—</>;
}
